import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Grid, CircularProgress} from '@material-ui/core';
import LoanPost from './LoanPost/LoanPost';
import useStyles from './styles';
import Button from '@material-ui/core/Button';

const LoanPosts = ({setCurrentId, setPageNumber, pageNumber, numberOfPages, totalPages}) =>{
    const classes = useStyles();  
    const posts = useSelector((state) => state.loanposts); // From the global state
    numberOfPages = totalPages;
    
    useEffect(()=>{
      numberOfPages = totalPages;
    }, [totalPages]);

    // Come back to previous page
    const gotoPrevious = () => {
        setPageNumber(Math.max(0, pageNumber - 1));
    };
    
    // Proceed to next page
    const gotoNext = () => {
        setPageNumber(Math.min(totalPages - 1, pageNumber + 1));
    };
    
    
    return(
        !posts.length && pageNumber > 0 ? <div> {setPageNumber(pageNumber - 1)} </div>  : (!posts.length ? <CircularProgress />:
          (
          <div>
            <Grid className = {classes.container} container alignItems = "stretch" spacing = {3}>
                {posts.map((post) => (
                    <Grid key ={post._id} item xs = {12} sm = {6}>
                        <LoanPost pageNumber = {pageNumber} post = {post} setCurrentId = {setCurrentId} /> 
                    </Grid>
                ))}   
            </Grid>
        
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '4vh'}}>
            <Button onClick={gotoPrevious} variant="contained" > Previous </Button>
            <p style={{ color: 'white' }}> &nbsp; Page {pageNumber + 1} of {numberOfPages} &nbsp; </p>
            <Button onClick={gotoNext} variant="contained" > Next </Button>}
          </div>
        </div>
        )))
}

export default LoanPosts;